import { render } from "./QuestsContainer.vue?vue&type=template&id=6dcc057e&scoped=true"
import script from "./QuestsContainer.vue?vue&type=script&lang=js"
export * from "./QuestsContainer.vue?vue&type=script&lang=js"

import "./QuestsContainer.vue?vue&type=style&index=0&id=6dcc057e&lang=scss&scoped=true"

import exportComponent from "/Users/Shared/PLAYLANE/Execution/P1901021/sandpiper/bbud-server/teacher-platform-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6dcc057e"]])

export default __exports__